// extracted by mini-css-extract-plugin
export default {"themeSelector":"styles_themeSelector__y1Wtq","label":"styles_label__eIbgK","select":"styles_select__gMh3R"};